import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer, Header } from '../Common';
import additionals from '../../Models/additionals';
class TermsConditions extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            privacy: ''
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        additionals.getPrivacy(2).then(res => {
            this.setState({ privacy: res.data.text })
        })
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const isTablet = (window.innerWidth < 1200 && window.innerWidth > 500);
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="" style={{ backgroundColor: "white",paddingTop:'10px' }}>
                            {/* <div className="col-md-2"></div> */}
                            <div className="">
                                <span style={{ fontSize: "20px" }}><b>{this.props.t('0')}</b></span>
                            </div>
                            {/* <div className="col-md-2"></div> */}
                        </div>
                        {/* <div className="col-md-12 row" style={{ backgroundColor: "white", height: "20px" }}></div> */}
                        <div className="" style={{ backgroundColor: "white",fontSize:'13px' }}>
                            <div className="col-md-2"></div>
                            <div className="col-md-8" style={{ backgroundColor: "#f4f2f0" }}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="m-2" style={{ height: "auto !important", padding: "3%", minHeight: "1100px", overflow: "auto" }}>
                                            {this.state.privacy.split('\n').map(function (item, key) {
                                                return (
                                                    <span key={key}>
                                                        {item}
                                                        <br />
                                                    </span>
                                                )
                                            })}

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="col-md-12 row" style={{ backgroundColor: "white" }}>
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <span style={{ fontSize: "35px" }}><b>{this.props.t('0')}</b></span>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                        {/* <div className="col-md-12 row" style={{ backgroundColor: "white", height: "20px" }}></div> */}
                        <div className="col-md-12 row" style={{ backgroundColor: "white" }}>
                            <div className="col-md-2"></div>
                            <div className="col-md-8" style={{ backgroundColor: "#f4f2f0" }}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="m-2" style={{ height: "auto !important", padding: "3%", minHeight: "1100px", overflow: "auto" }}>
                                            {this.state.privacy.split('\n').map(function (item, key) {
                                                return (
                                                    <span key={key}>
                                                        {item}
                                                        <br />
                                                    </span>
                                                )
                                            })}

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { TermsConditions }

 TermsConditions = withTranslation('src_Components_StaticPages_TermsConditions')(TermsConditions);